
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[resort]/schneestatistik",
      function () {
        return require("private-next-pages/[region]/[resort]/schneestatistik.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[resort]/schneestatistik"])
      });
    }
  